import React, { useState, useRef } from 'react';
import axios from 'axios';
import { globals } from '../globals';

const UploadImages = () => {
  const [files, setFiles] = useState([]);
  const [uploadProgress, setUploadProgress] = useState({});
  const [uploadStatus, setUploadStatus] = useState({}); // Stato per pallini di stato
  const fileInputRef = useRef(null); // Riferimento all'input file

  const handleFileChange = (event) => {
    setFiles(event.target.files);
    setUploadProgress({});
    setUploadStatus({});
  };

  const handleReset = () => {
    setFiles([]); // Resetta i file selezionati
    setUploadProgress({}); // Resetta i progressi
    setUploadStatus({}); // Resetta gli stati di upload
    fileInputRef.current.value = null; // Resetta il campo file
  };

  const handleUpload = async () => {
    if (files.length === 0) {
      alert('Seleziona almeno un file prima di fare l\'upload.');
      return;
    }

    const newProgress = {};
    const newStatus = {};
    setUploadProgress(newProgress);
    setUploadStatus(newStatus);

    const promises = Array.from(files).map((file) => {
      const formData = new FormData();
      formData.append('images[]', file);

      return axios.post(globals.homepageUrl + '/php/upload.php', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        onUploadProgress: (progressEvent) => {
          const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          setUploadProgress((prevProgress) => ({
            ...prevProgress,
            [file.name]: percentCompleted,
          }));
        },
      }).then(() => {
        setUploadStatus((prevStatus) => ({
          ...prevStatus,
          [file.name]: 'success', // Stato di successo
        }));
      }).catch(() => {
        setUploadStatus((prevStatus) => ({
          ...prevStatus,
          [file.name]: 'error', // Stato di errore
        }));
      });
    });

    await Promise.all(promises); // Attendi il completamento di tutti i caricamenti
  };

  // Funzione per formattare la dimensione del file in KB/MB
  const formatFileSize = (size) => {
    if (size < 1024) return `${size} B`;
    else if (size < 1048576) return `${(size / 1024).toFixed(2)} KB`;
    else return `${(size / 1048576).toFixed(2)} MB`;
  };

  return (
    <div style={{ fontFamily: 'Arial, sans-serif', padding: '20px', maxWidth: '500px', margin: '0 auto',minHeight:'800px' }}>
      <h1 style={{ textAlign: 'center', color: '#444' }}>Carica le tue Immagini</h1>
      
      <input
        ref={fileInputRef} // Associa il ref all'input file
        type="file"
        multiple
        onChange={handleFileChange}
        style={{
          display: 'block',
          marginBottom: '15px',
          width: '100%',
          padding: '10px',
          border: '1px solid #ddd',
          borderRadius: '5px',
          fontSize: '14px',
        }}
      />
      
      {/* Bottone per resettare la selezione dei file */}
      <button
        onClick={handleReset}
        style={{
          display: 'block',
          width: '100%',
          padding: '12px',
          backgroundColor: '#dc3545',
          color: 'white',
          border: 'none',
          borderRadius: '5px',
          cursor: 'pointer',
          fontSize: '16px',
          marginBottom: '20px',
          transition: 'background-color 0.3s',
        }}
        onMouseOver={(e) => (e.target.style.backgroundColor = '#c82333')}
        onMouseOut={(e) => (e.target.style.backgroundColor = '#dc3545')}
      >
        Resetta Selezione Immagini
      </button>
      
      {/* Bottone per caricare le immagini */}
      <button
        onClick={handleUpload}
        style={{
          display: 'block',
          width: '100%',
          padding: '12px',
          backgroundColor: '#0066CC',
          color: 'white',
          border: 'none',
          borderRadius: '5px',
          cursor: 'pointer',
          fontSize: '16px',
          marginBottom: '20px',
          transition: 'background-color 0.3s',
        }}
        onMouseOver={(e) => (e.target.style.backgroundColor = '#004999')}
        onMouseOut={(e) => (e.target.style.backgroundColor = '#0066CC')}
      >
        Carica Immagini
      </button>
      
      {/* Tabella per mostrare i file selezionati, dimensioni e barra di progresso */}
      <table style={{ width: '100%', borderCollapse: 'collapse' }}>
        <thead>
          <tr>
            <th style={{ textAlign: 'left', padding: '8px', borderBottom: '1px solid #ddd' }}>Nome File</th>
            <th style={{ textAlign: 'left', padding: '8px', borderBottom: '1px solid #ddd' }}>Dimensione</th>
            <th style={{ textAlign: 'left', padding: '8px', borderBottom: '1px solid #ddd' }}>Progresso</th>
            <th style={{ textAlign: 'center', padding: '8px', borderBottom: '1px solid #ddd' }}>Stato</th>
          </tr>
        </thead>
        <tbody>
          {Array.from(files).map((file) => (
            <tr key={file.name}>
              <td style={{ padding: '8px', borderBottom: '1px solid #ddd' }}>
                <span style={{ fontSize: '14px', fontWeight: 'bold' }}>{file.name}</span>
              </td>
              <td style={{ padding: '8px', width:'100px',borderBottom: '1px solid #ddd', fontSize: '12px', color: '#666'}}>
                {formatFileSize(file.size)}
              </td>
              <td style={{ display: 'flex',padding: '8px', borderBottom: '1px solid #ddd',alignItems:'center' }}>
                <div style={{ display: 'inline-block', width: '75%', height: '20px', backgroundColor: '#e0e0e0', borderRadius: '4px', overflow: 'hidden' }}>
                  <div style={{
                    width: `${uploadProgress[file.name] || 0}%`,
                    backgroundColor: '#28a745',
                    height: '100%',
                    border: '1px solid darkgray',
                    borderRadius: '4px',
                    transition: 'width 0.3s ease',
                  }}></div>
                </div>
                <span style={{
                  fontSize: '12px',
                  color: '#666',
                  marginTop: '0px',
                  marginLeft: '5px',
                  display: 'block',
                }}>
                  {uploadProgress[file.name] || 0}%
                </span>
              </td>
              <td style={{ textAlign: 'center', padding: '8px', borderBottom: '1px solid #ddd' }}>
                {uploadProgress[file.name] === 100 && (
                  <i className="fa fa-check-circle" style={{ fontSize: '20px', color: '#28a745' }}></i>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default UploadImages;
